import * as React from "react";
const SvgArrowBack = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.47 19.53a.75.75 0 1 0 1.06-1.06L10.06 12l6.47-6.47a.75.75 0 0 0-1.06-1.06l-7 7a.75.75 0 0 0 0 1.06v.001l7 7Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgArrowBack;
